import React from 'react';
import './FieldError.css';

const FieldError = ({ error, className = '' }) => {
  if (!error) return null;

  return (
    <div className={`field-error ${className}`}>
      <span className="error-icon">⚠️</span>
      <span className="error-message">{error}</span>
    </div>
  );
};

export default FieldError;
